import 'css-chunksrc/client/pages/zonesPage/projectsPage/toolbar/sort/styles.scss';export default {
  "root": "_root_g6bpd_1",
  "listRoot": "_listRoot_g6bpd_5",
  "input": "_input_g6bpd_13",
  "opened": "_opened_g6bpd_32",
  "icon": "_icon_g6bpd_37",
  "list": "_list_g6bpd_5",
  "option": "_option_g6bpd_59",
  "selected": "_selected_g6bpd_66"
};